// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"72fd6dc7","212":"16736ff3","273":"6432b1fc","316":"0bbe396e","564":"4184b006","635":"16736ff3","776":"5d57baf6"}[chunkId] + ".chunk.css";
};